/**
 * Authentication Event System
 * Industry-standard approach for handling auth state changes
 * without page reloads or global variables
 */

class AuthEventEmitter extends EventTarget {
  constructor() {
    super();
    this.TOKEN_EXPIRED = 'token-expired';
    this.TOKEN_REFRESHED = 'token-refreshed';
    this.LOGOUT_REQUIRED = 'logout-required';
  }

  emitTokenExpired() {
    this.dispatchEvent(new CustomEvent(this.TOKEN_EXPIRED));
  }

  emitTokenRefreshed(newToken) {
    this.dispatchEvent(new CustomEvent(this.TOKEN_REFRESHED, { detail: { token: newToken } }));
  }

  emitLogoutRequired() {
    this.dispatchEvent(new CustomEvent(this.LOGOUT_REQUIRED));
  }

  onTokenExpired(callback) {
    this.addEventListener(this.TOKEN_EXPIRED, callback);
    return () => this.removeEventListener(this.TOKEN_EXPIRED, callback);
  }

  onTokenRefreshed(callback) {
    this.addEventListener(this.TOKEN_REFRESHED, callback);
    return () => this.removeEventListener(this.TOKEN_REFRESHED, callback);
  }

  onLogoutRequired(callback) {
    this.addEventListener(this.LOGOUT_REQUIRED, callback);
    return () => this.removeEventListener(this.LOGOUT_REQUIRED, callback);
  }
}

// Singleton instance
const authEvents = new AuthEventEmitter();
export default authEvents;